import { IGetAllProjetoImpressaoUseCase } from "../../../presentation/useCases/read/get_all_projeto_impressao_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IProjetosRepository } from "../../repositories/projetos_repository";
import { ProjetoImpressaoLista } from "../../models/impressao_projeto_lista";

/**
 * GetAllProjetoImpressaoUseCase
 */

export class GetAllProjetoImpressaoUseCase
  extends BasePaginatedUseCase<ProjetoImpressaoLista>
  implements IGetAllProjetoImpressaoUseCase {
  constructor(private readonly repository: IProjetosRepository) {
    super();
  }

  async execute(
    idsProjeto?: number[],
    idsCentrocusto?: number[],
    idsSolicitante?: number[],
    status?: number,
    statusEmail?: number,
    dataDe?: Date,
    dataAte?: Date,

    currentPage?: number,
    rowsPerPage?: number
  ): Promise<void> {

    const response = await this.repository.getAllProjetoImpressao(
      idsProjeto,
      idsCentrocusto,
      idsSolicitante,
      status,
      statusEmail,
      dataDe,
      dataAte,
      currentPage,
      rowsPerPage
    );

    this._items = response.items;
    this._totalPages = response.totalPages;
    this._totalItems = response.totalItems;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
  }
}
